export default __webpack_public_path__ + "static/media/icone-redaction-contenu.41a5fd6e.svg";